import '../components/customPatternModal';
import { ContentItemTypes } from 'modules/Boards/Types';
import AddToMyBoards from '../components/addToMyBoards';
import * as GoogleTagManager from '../modules/GoogleTagManager';
import { createElement } from '../modules';
import { utility } from '../modules/utility';

const { i18n, CustomPatternModal } = ShawContract;
// Localization
const translations = JSON.parse($('#collectionTranslations').val());
const sizeLabel = i18n.Size;
const backingLabel = i18n.Backing;
const finishLabel = i18n.Finish;
const constructionLabel = translations.Construction;
const customize = translations.Customize;
const machineTypeLabel = i18n.MachineType;
const patternTypeLabel = i18n.PatternType;

const productUrlGeneric = `${$('#ProductGenericUrl').val()}/`;
const leftPartUrl = $('#UrlLeftPart').val();
const productUrl = leftPartUrl + productUrlGeneric;
const collectionProducts = $('#collectionProducts').val();
const collectionAllowShipping = $('#collectionAllowShipping').val();
const collectionAllowRugsOrdering = $('#collectionAllowRugsOrdering').val();

const runningLineSectionContainer = document.getElementById(
  'running-line-container',
);
const runningLineSection = document.getElementById('running-line-section');
const customPatternSectionContainer = document.querySelector(
  '.custom-pattern-products-wrapper .row',
);
const patternSelect = document.getElementById('pattern-type');
const machineSelect = document.getElementById('machine-type');
const viewAllBtn = document.getElementById('view-all');

const widgetArea = document.getElementById('bottom-widget-area');
const firstWidget = widgetArea.querySelector('.widget');
const viewStoryBtn = document.getElementById('view-story-btn');
const addToBoardBtn = document.getElementById('add-to-board');

// STATE
const allPatternTypeValue = patternSelect.value;
const allMachineTypeValue = machineSelect.value;
let customPatterns = [];
let filteredCustomPatterns = [];
const selectedFilters = {
  PatternType: allPatternTypeValue,
  MachineType: allMachineTypeValue,
};

function addToBoard(e) {
  const title = e.currentTarget.getAttribute('data-collection-title');
  AddToMyBoards.openModal(ContentItemTypes.collection, null, null, title);

  // GTM track Add to Board CTA Clic
  window.dataLayer.push({
    event: 'board-cta-click',
    clickText: e.target.innerText.slice(1), // remove preceeding space
    pageLocation: location.pathname,
  });
}

$(addToBoardBtn).on('click', addToBoard);

function createProductProperties(properties) {
  return properties
    .filter((prop) => prop.every((a) => a))
    .map((prop) => createElement({
      element: 'div',
      classes: 'prod-card__prop-label',
      children: [
        createElement({
          element: 'div',
          text: `${prop[0]}: `,
        }),
        createElement({
          element: 'div',
          classes: 'prod-card__prop-value',
          text: prop[1],
        }),
      ],
    }));
}

function renderCustomPatternProducts(arr) {
  for (let i = 0; i < arr.length; i++) {
    const customProd = arr[i];

    const properties = [
      [sizeLabel, customProd.Size],
      [machineTypeLabel, customProd.MachineType],
      [patternTypeLabel, customProd.PatternType],
    ];

    console.log(i18n);
    console.log(translations);
    const img = createElement({
      element: 'div',
      classes: 'prod-card-img',
      children: [
        createElement({
          element: 'span',
          classes: 'customize white',
          text: `${i18n['Collection.Button.Customize']}`,
        }),
        createElement({
          element: 'img',
          classes: 'lazyload prod-card__img',
          attributes: {
            'data-src': `https://foundry.img.trykcloudstatic.com/designs/${customProd.StyleNumber}/install?physWidth=72in&physHeight=50in&pixels=290`,
            'data-img': `https://foundry.img.trykcloudstatic.com/designs/${customProd.StyleNumber}/install?physWidth=72in&physHeight=50in&pixels=500`,
            'data-product-name': customProd.StyleName,
            'data-style-number': customProd.StyleNumber,
            'data-size': customProd.Size,
            'data-machine-type': customProd.MachineType,
            'data-pattern-type': customProd.PatternType,
            'data-customize-url': `https://foundry.shawhospitality.com/designs/${customProd.StyleNumber}?v=2d`,
          },
        }),
      ],
    });

    const header = createElement({
      classes: 'prod-card__header',
      children: [
        createElement({
          element: 'span',
          text: `${customProd.StyleName} `,
        }),
        createElement({
          element: 'span',
          text: customProd.StyleNumber,
        }),
      ],
    });

    const propsWrapper = createElement({
      classes: 'row no-gutters',
      children: createProductProperties(properties),
    });

    createElement({
      appendTo: customPatternSectionContainer,
      classes: 'col-12 col-md-6 col-lg-4 prod-card',
      children: [img, header, propsWrapper],
    });
  }
  CustomPatternModal.addEventListenersToOpenModal(
    '.custom-pattern-products-wrapper .prod-card__img',
  );
  ShawContract.lazyLoadImages();
}

function createCustomPatternSection(arr) {
  customPatterns = arr;
  if (customPatterns.length === 0) {
    $('.custom-pattern-section').hide();
  } else {
    renderCustomPatternProducts(customPatterns.slice(0, 9));
  }

  if (customPatterns.length <= 9) {
    $(viewAllBtn).remove();
  }
}

function createRunningLineProduct(prod, container) {
  if (prod && prod.StyleName) {
    const productFullUrl = productUrl + prod.StyleNumber;
    const gtmEventData = {
      id: prod.StyleNumber,
      name: prod.StyleName,
      category: prod.ProductType,
    };

    let properties = [
      [sizeLabel, prod.Size],
      [backingLabel, prod.Backing],
      [i18n.Thickness, prod.OverallThickness],
      ['Ware Layer', prod.WareLayer],
      [constructionLabel, prod.Construction],
      [finishLabel, prod.Finish],
    ];

    if (prod.ProductType === 'Tile' || prod.ProductType === 'Broadloom') {
      properties = [
        [sizeLabel, prod.Size],
        [backingLabel, prod.Backing],
        [i18n.Thickness, prod.OverallThickness],
        ['Ware Layer', prod.WareLayer],
        [finishLabel, prod.Finish],
      ];
    }

    createElement({
      appendTo: container,
      classes: 'col-12 col-md-6 col-lg-4 prod-card',
      children: [
        createElement({
          element: 'a',
          attributes: { href: productFullUrl },
          eventListeners: {
            click: () => GoogleTagManager.productClick(gtmEventData),
          },
          children: [
            createElement({
              element: 'img',
              classes: 'lazyload prod-card__img',
              attributes: { 'data-src': prod.ImageUrl },
              eventListeners: {
                load: () => GoogleTagManager.productImpression(gtmEventData),
              },
            }),
          ],
        }),

        createElement({
          classes: 'prod-card__header',
          children: [
            createElement({
              element: 'a',
              attributes: { href: productFullUrl },
              eventListeners: {
                click: () => GoogleTagManager.productClick(gtmEventData),
              },
              children: [
                createElement({
                  element: 'span',
                  classes: 'black medium',
                  text: `${prod.StyleName} `,
                }),
                createElement({
                  element: 'span',
                  text: prod.StyleNumber,
                }),
              ],
            }),
          ],
        }),

        createElement({
          classes: 'row no-gutters',
          children: createProductProperties(properties),
        }),
      ],
    });
  }
}

function createRugProduct(arr) {
  for (let i = 0; i < arr.length; i++) {
    const prod = arr[i];
    const contentClass = prod.ProductType.split(' ').join('');
    const container = document.querySelector(`.${contentClass} .content`);
    if (prod && prod.StyleName) {
      const productFullUrl = productUrl + prod.StyleNumber;
      const gtmEventData = {
        id: prod.StyleNumber,
        name: prod.StyleName,
        category: prod.ProductType,
      };

      const properties = {
        sizeLabel: prod.GroppedSizes,
        pattern: prod.ParentPattern,
        price:
          `$${
            formatPrice(prod.PriceRange[0])
          } - $${
            formatPrice(prod.PriceRange[1])}`,
        url: productFullUrl,
      };
      const sergeType = prod.EdgeType == 'Yarn Serge' ? 1 : 2;
      let imageSrcMain = `https://scrl.img.trykcloudstatic.com/designs/${
        prod.StyleNumber
      }/colors/${
        prod.Colors[0].ColorNumber
      }/arearug?sergeType=${
        sergeType
      }&physWidth=6`
        + 'ft&physHeight=9ft&shape=Rectangle&pixels=500';
      if (prod.GroppedSizes.indexOf(',') == -1 && prod.Shape == 'Circle') {
        imageSrcMain = `https://scrl.img.trykcloudstatic.com/designs/${
          prod.StyleNumber
        }/colors/${
          prod.Colors[0].ColorNumber
        }/arearug?sergeType=${
          sergeType
        }&physWidth=11`
          + `ft&physHeight=11ft&shape=${
            prod.Shape
          }&pixels=500`;
        properties.price = `$${formatPrice(prod.Price.Price)}`;
      }

      createElement({
        appendTo: container,
        classes: 'col-6 col-lg-4 prod-card card product-card rugsSection',
        children: [
          createElement({
            classes: 'image-wrapper',
            children: [
              createElement({
                element: 'a',
                classes: 'stretched-link',
                attributes: { href: productFullUrl },
                eventListeners: {
                  click: () => GoogleTagManager.productClick(gtmEventData),
                },
                children: [
                  createElement({
                    element: 'img',
                    classes: 'lazyload prod-card__img',
                    attributes: { 'data-src': imageSrcMain },
                    eventListeners: {
                      load: () => GoogleTagManager.productImpression(gtmEventData),
                    },
                  }),
                  createElement({
                    element: 'img',
                    classes: 'card-img hidden lazyload',
                    attributes: {
                      'data-src': prod.ImageUrl.replace('250', '500'),
                    },
                  }),
                ],
              }),
            ],
          }),
          createElement({
            classes: 'row no-gutters',
            children: [
              createElement({
                classes: 'card-body',
                children: [
                  createElement({
                    classes: 'd-flex justify-content-between',
                    children: [
                      createElement({
                        element: 'span',
                        classes:
                          'black heading-4 hover-red text-decoration-none transition-color',
                        text: properties.pattern,
                      }),
                    ],
                  }),
                  createElement({
                    classes:
                      'text-size-small gray-regular medium mt-2 floatLeft',
                    text: properties.sizeLabel
                      .replace(/["\s]/g, '')
                      .replace(/[,]/g, ', ')
                      .replace(/ft/g, ''),
                  }),
                  createElement({
                    classes:
                      'text-size-small black-regular medium mt-2 floatRight',
                      text: properties.price,
                      shouldRender: collectionAllowShipping && JSON.parse(collectionAllowShipping) &&
                          collectionAllowRugsOrdering && JSON.parse(collectionAllowRugsOrdering)
                  }),
                ],
              }),
            ],
          }),
        ],
      });
    }
  }
}

function createRunningLineSection(arr) {
  if (Array.isArray(arr.Products)) {
    if (arr.Products.length === 0) {
      $(runningLineSection).hide();
      return;
    }

    if (arr.Type != null && arr.Type != 'area rug') {
      createElement({
        appendTo: runningLineSectionContainer,
        classes: ['subtype-wrapper', arr.Type.split(' ').join('')],
        children: [
          createElement({
            classes: 'product-type',
            text: arr.Type,
          }),
          createElement({
            classes: 'row content',
          }),
        ],
      });

      const contentClass = arr.Type.split(' ').join('');
      const specificContent = document.querySelector(
        `.${contentClass} .content`,
      );

      for (let j = 0; j < arr.Products.length; j++) {
        createRunningLineProduct(arr.Products[j], specificContent);
      }
    }
  }
}

function createRugSection(arr) {
  const allProducts = arr;
  if (Array.isArray(arr)) {
    if (arr.length === 0) {
      $(runningLineSection).hide();
      return;
    }

    arr = arr.slice(0, 6);
    createElement({
      appendTo: runningLineSectionContainer,
      classes: ['subtype-wrapper', arr[0].ProductType.split(' ').join('')],
      children: [
        createElement({
          classes: 'product-type',
          text: arr[0].ProductType,
        }),
        createElement({
          classes: 'row content',
        }),
      ],
    });

    createRugProduct(arr);

    if (allProducts.length > 6) {
      createElement({
        appendTo: runningLineSectionContainer,
        classes: [
          'justify-content-center',
          'row',
          arr[0].ProductType.split(' ').join(''),
        ],
        children: [
          createElement({
            classes: 'col-lg-2 col-sm-12',
            children: [
              createElement({
                element: 'button',
                attributes: { id: 'view-all-rugs' },
                classes: 'btn btn-tertiary w-100 my-5',
                text: 'View all',
              }),
            ],
          }),
        ],
      });

      document.getElementById('view-all-rugs').onclick = function (e) {
        createRugProduct(allProducts.slice(6));
        $(this).hide();
        ShawContract.lazyLoadImages();
      };
    }
  }
}

function formatPrice(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function groupBy(input, key) {
  return input.reduce((acc, value) => {
    if (!acc[value[key]]) {
      acc[value[key]] = [];
    }

    // Grouping
    acc[value[key]].push(value);

    return acc;
  }, {});
}

function getProducts() {
  const response = JSON.parse(collectionProducts);
  if (response.ProductGroups.length > 0) {
    response.ProductGroups.sort(compareProductGroups);

    response.ProductGroups.forEach((item, index) => {
      if (item.Type == 'area rug') {
        const products = [];
        const filteredProducts = groupBy(item.Products, 'ParentPattern');
        for (const [key, value] of Object.entries(filteredProducts)) {
          let groppedSizes = [];
          const innerProduct = [];
          const priceRange = [value[0].Price?.Price, 0];
          let prod = null;
          for (let i = 0; i < value.length; i++) {
            prod = value[i];
            if (!groppedSizes.includes(prod.Size)) {
              groppedSizes.push(prod.Size);
            }
            if (parseInt(prod.Price?.Price) < priceRange[0]) {
              priceRange[0] = parseInt(prod.Price.Price);
            }
            if (parseInt(prod.Price?.Price) > priceRange[1]) {
              priceRange[1] = parseInt(prod.Price.Price);
            }
          }
          priceRange[1] = formatPrice(priceRange[1]);
          priceRange[0] = formatPrice(priceRange[0]);
          groppedSizes = groppedSizes.sort((a, b) => parseInt(a) - parseInt(b));
          prod.GroppedSizes = groppedSizes.join(', ');
          prod.PriceRange = priceRange;
          prod.StyleNumber = value[0].StyleNumber;
          prod.StyleName = value[0].StyleName;
          prod.Size = value[0].Size;
          prod.Shape = value[0].Shape;

          products.push(prod);
        }
        createRugSection(products);
      } else {
        createRunningLineSection(item);
      }
    });
  }
  createCustomPatternSection(response.CustomPatterns);
  ShawContract.lazyLoadImages();
}

function filterCustomPatterns() {
  return customPatterns.filter((item) => Object.keys(selectedFilters).every((key) => {
    if (
      item[key] === selectedFilters[key]
        || selectedFilters[key] === allMachineTypeValue
    ) {
      return true;
    }
    return false;
  }));
}

function applyFilters() {
  filteredCustomPatterns = [];
  utility.removeChildren(customPatternSectionContainer);

  filteredCustomPatterns = filterCustomPatterns();

  if (filteredCustomPatterns.length > 0) {
    renderCustomPatternProducts(filteredCustomPatterns.slice(0, 9));
  } else {
    createElement({
      element: 'h3',
      appendTo: customPatternSectionContainer,
      text: 'No results!',
      classes: 'text-center w-100 mt-5',
    });
  }

  if (filteredCustomPatterns.length <= 9) {
    $(viewAllBtn).hide();
  } else {
    $(viewAllBtn).show();
  }
}

function compareProductGroups(a, b) {
  const areaRugType = 'area rug';

  if (a.Type == areaRugType && b.Type != areaRugType) {
    return -1;
  }
  if (a.Type != areaRugType && b.Type == areaRugType) {
    return 1;
  }
  return 0;
}

// Event Listeners
$(machineSelect).on('change', (e) => {
  selectedFilters.MachineType = e.target.value;
  applyFilters();
});

$(patternSelect).on('change', (e) => {
  selectedFilters.PatternType = e.target.value;
  applyFilters();
});

$(viewAllBtn).on('click', () => {
  if (
    selectedFilters.PatternType === allPatternTypeValue
    && selectedFilters.MachineType === allMachineTypeValue
  ) {
    renderCustomPatternProducts(customPatterns.slice(9));
  } else {
    renderCustomPatternProducts(filteredCustomPatterns.slice(9));
  }

  $(viewAllBtn).hide();
});

if (firstWidget && viewStoryBtn) {
  $(viewStoryBtn).on('click', () => {
    firstWidget.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
} else {
  $(viewStoryBtn).hide();
}

function onInit() {
  getProducts();
}

onInit();
